import { render, staticRenderFns } from "./DashCapSquareIcon.vue?vue&type=template&id=060926d1&"
import script from "./DashCapSquareIcon.vue?vue&type=script&lang=js&"
export * from "./DashCapSquareIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports